module.exports = __webpack_public_path__ + "img/login-bg.5647f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg.png
// module id = QPNa
// module chunks = 1